import vueTypes from 'vue-types'

const vacancySharable = {
  id: vueTypes.any,
  url: vueTypes.string,
  title: vueTypes.string,
  position: vueTypes.number
}

const vacancyFromSource = vueTypes.shape({
  ...vacancySharable,
  job_type_id: vueTypes.any,
  position_job_types: vueTypes.number,
  department_id: vueTypes.any,
  position_departments: vueTypes.number,
  location_id: vueTypes.any,
  position_locations: vueTypes.number
})

export const vacancy = vueTypes.shape({
  ...vacancySharable,
  type: vueTypes.oneOfType([
    null,
    vueTypes.shape({
      id: vueTypes.any,
      position: vueTypes.number,
      name: vueTypes.string
    }),
  ]),
  displayTypes: vueTypes.arrayOf(vueTypes.string),
  queryTypes: vueTypes.string,
  tags: vueTypes.object,
  visibility: vueTypes.shape({
    query: vueTypes.bool,
    tags: vueTypes.bool
  })
})

export const i18n = vueTypes.object

const headings = vueTypes.shape({
  fontFamily: vueTypes.string,
  fontSize: vueTypes.string,
  fontWeight: vueTypes.string,
  lineHeight: vueTypes.string,
  letterSpacing: vueTypes.string
})

const vacancies = vueTypes.shape({
  paddingTop: vueTypes.string,
  paddingBottom: vueTypes.string,
  textColor: vueTypes.string,
  headingColor: vueTypes.string,
  backgroundColor: vueTypes.string,
  backgroundOpacity: vueTypes.number,
  backgroundImage: vueTypes.any
})

export const css = vueTypes.shape({
  headings,
  modules: vueTypes.shape({
    vacancies
  }),
  borderRadius: vueTypes.any
}).def({})

export const view = vueTypes.shape({
  theme: vueTypes.string,
  listView: vueTypes.bool,
  advancedFilters: vueTypes.bool,
  groupBy: vueTypes.string,
  showNavigation: vueTypes.bool
}).def({})

export const content = vueTypes.shape({
  departments: vueTypes.array,
  locations: vueTypes.array,
  job_types: vueTypes.array,
  vacancies: vueTypes.arrayOf(vacancyFromSource),
  language: vueTypes.string
}).def({})

export default {content, css, view, i18n}
